angular.module('clientDashboardApp.admin.users.accounts.userAccountsEditor', [
  'clientDashboardApp.admin.users.userManagerService'
]).controller("UserAccountsEditorCtrl", UserAccountsEditorCtrl);

UserAccountsEditorCtrl.$inject = ['$state', '$stateParams', 'accounts', 'user', 'accountsService'];
function UserAccountsEditorCtrl($state, $stateParams, accounts, user, accountsService) {
  let vm = this;

  vm.SELECTED_ONLY = 'SELECTED_ONLY';
  vm.ALL = 'ALL';

  vm.UNSELECTED_ONLY = 'UNSELECTED_ONLY';
  vm.accounts = _.sortBy(accounts, account => account.accountName.toLowerCase()).map(account => ({...account}));
  vm.user = user;
  vm.userId = $stateParams.userId;
  vm.accountQuery = "";
  vm.selectedFilter = vm.ALL;

  vm.pagination = {
    currentPage: 1,
    perPage: 20
  }

  const allAccountsSelected = () => vm.filteredAccounts().findIndex(account => !account.selected) === -1

  vm.toggleAllAccounts = function() {
    const checked = vm.toggleAllCheckbox;

    vm.filteredAccounts()
      .forEach(account => {
        account.selected = checked
        vm.addToCurrentEditSet(account)
      })

    vm.toggleAllCheckbox = allAccountsSelected();
  };


  const currentEditSessionChanges = new Set()

  vm.filteredAccounts = () => {
    let filteredAccounts = vm.accounts;
    switch (vm.selectedFilter) {
      case vm.SELECTED_ONLY:
        filteredAccounts = _.filter(filteredAccounts, account => account.selected == true || vm.currentEditSetContains(account))
        break;
      case vm.UNSELECTED_ONLY:
        filteredAccounts = _.filter(filteredAccounts, account => account.selected !== true || vm.currentEditSetContains(account))
        break;
    }

    let query = vm.accountQuery.toLowerCase().trim();
    if (query.length == 0) {
      return filteredAccounts;
    }
    return _.filter(filteredAccounts, (account) => {
      return vm.accountQuery.length == 0 || account.accountName.toLowerCase().indexOf(query) != -1
    })
  }

  vm.pagedAccounts = () => {
    let startIndex = (vm.pagination.currentPage - 1) * vm.pagination.perPage;
    return vm.filteredAccounts().slice(startIndex, startIndex + vm.pagination.perPage)
  }

  vm.saveChanges = () => {
    vm.saving = true
    let userAccounts = _.filter(vm.accounts, account => account.selected).map(account => account.id);
    vm.resetEditSession()
    accountsService.updateUserAccounts(user.id, userAccounts).then(() => $state.go("admin_v2.users"))
  }

  vm.toggleAccountStatus = (account, $event) => {
    if (account) {
      account.selected = !account.selected
      vm.addToCurrentEditSet(account)
    }
    if ($event) {
      $event.stopPropagation()
    }
  }

  vm.currentEditSetContains = account => currentEditSessionChanges.has(account.id)
  vm.addToCurrentEditSet = account => currentEditSessionChanges.add(account.id)
  vm.resetEditSession = () => currentEditSessionChanges.clear()
  vm.currentEditSetHasChanges = () => currentEditSessionChanges.size > 0

}
